export default {
    all: { method: 'GET', url: 'orcamento/all' },
    active: { method: 'GET', url: 'orcamento/active' },
    get: { method: 'GET', url: 'orcamento/get{/id}' },
    create: { method: 'POST', url: 'orcamento' },
    update: { method: 'PUT', url: 'orcamento' },
    inactive: { method: 'DELETE', url: 'orcamento{/id}' },
};